module.exports = __webpack_public_path__ + "media/images/step-recource-4b169f84bd3939a8f6010d3fdd40ab46.png";